module.exports = __webpack_public_path__ + "img/open_middle.2f884964.png";